import 'core-js/features/object';

import { platform } from './platform';

export const track = (event: string, properties: object): void => {
  const amendedProperties = Object.assign(
    {
      platform,
      product: process.env.SEGMENT_PRODUCT,
    },
    properties
  );

  if ((window as any).analytics) {
    (window as any).analytics.track(event, amendedProperties);
  }
};
